import { useCallback } from 'react';
import { Chip } from '@sunwebgroup/ui-components';
import { useSelectFilter } from '@/scopes/search/search/domain/hooks';
import { useIntl } from '@/intl';

function DistanceToCenterChips() {
  const intl = useIntl();
  const { isFetching, isLoading, selectedOption, selectedValue, setSelection } = useSelectFilter('MetersToCenter');

  const handleRemoveClick = useCallback(() => {
    setSelection(null);
  }, [setSelection]);

  if (isLoading) return null;
  if (!selectedOption) return null;

  return (
    <Chip value={selectedValue} disabled={isFetching} removable onRemoveClick={handleRemoveClick}>
      {selectedOption.value === '0'
        ? selectedOption.name
        : intl.formatMessage({ id: 'filter_chips_distance_to_centre' }, { distance: selectedOption.name })}
    </Chip>
  );
}

function DistanceToBeachChips() {
  const intl = useIntl();
  const { isFetching, isLoading, selectedOption, selectedValue, setSelection } = useSelectFilter('MetersToBeach');

  const handleRemoveClick = useCallback(() => {
    setSelection(null);
  }, [setSelection]);

  if (isLoading) return null;
  if (!selectedOption) return null;

  return (
    <Chip value={selectedValue} disabled={isFetching} removable onRemoveClick={handleRemoveClick}>
      {selectedOption.value === '0'
        ? selectedOption.name
        : intl.formatMessage({ id: 'filter_chips_distance_to_beach' }, { distance: selectedOption.name })}
    </Chip>
  );
}

export function DistanceToInterestChips() {
  return (
    <>
      <DistanceToCenterChips />
      <DistanceToBeachChips />
    </>
  );
}
